export default __webpack_public_path__ + "static/outer_top-bb116d7ac7ec7de25cc5319a40a69dcc.png";